import React from "react";

import CenteredLayout from "layouts/CenteredLayout";
import ResetPasswordForm from "components/ResetPasswordForm";
import { useAppMeta } from "hooks";

const ResetPasswordScreen = () => {
  useAppMeta("Reset Password");

  return (
    <CenteredLayout>
      <ResetPasswordForm />
    </CenteredLayout>
  );
};

export default ResetPasswordScreen;
